function initOrderNoteUpdater(scope = document) {
  var citySelect = scope.querySelector("#city-select");
  var districtSelect = scope.querySelector("#district-select");
  var orderNoteInput = scope.querySelector("#cart-note");
  var checkoutButton = scope.querySelector("#checkout");

  if (!citySelect || !districtSelect || !orderNoteInput || !checkoutButton) return;
  if (checkoutButton.dataset.orderNoteInitialized === "true") return;

  checkoutButton.dataset.orderNoteInitialized = "true";

  function updateOrderNote() {
    var selectedCity =
      citySelect.options[citySelect.selectedIndex] &&
      citySelect.options[citySelect.selectedIndex].text
        ? citySelect.options[citySelect.selectedIndex].text
        : "";

    var selectedDistrict =
      districtSelect.options[districtSelect.selectedIndex] &&
      districtSelect.options[districtSelect.selectedIndex].text
        ? districtSelect.options[districtSelect.selectedIndex].text
        : "";

    if (
      !selectedCity ||
      !selectedDistrict ||
      selectedCity === "-- Seçin --" ||
      selectedDistrict === "-- Seçin --"
    ) {
      return;
    }

    var cityDistrictJSON = JSON.stringify({
      il: selectedCity,
      "ilçe": selectedDistrict
    });

    var existingNote = orderNoteInput.value || "";

    var pattern = /{\s*"il":\s*"[^"]+",\s*"ilçe":\s*"[^"]+"\s*}/;
    var existingCityDistrict = existingNote.match(pattern);

    if (existingCityDistrict) {
      orderNoteInput.value = existingNote.replace(pattern, cityDistrictJSON);
    } else {
      orderNoteInput.value = existingNote + (existingNote ? " | " : "") + cityDistrictJSON;
    }

    orderNoteInput.dispatchEvent(new Event("change", { bubbles: true }));
    orderNoteInput.dispatchEvent(new Event("input", { bubbles: true }));
  }

  checkoutButton.addEventListener("click", function () {
    updateOrderNote();
  });

  citySelect.addEventListener("change", updateOrderNote);
  districtSelect.addEventListener("change", updateOrderNote);
}

document.addEventListener("DOMContentLoaded", function () {
  initOrderNoteUpdater(document);

  var cartDrawer = document.querySelector("cart-drawer, .cart-drawer, [data-cart-drawer]");
  if (!cartDrawer) return;

  var observer = new MutationObserver(function () {
    initOrderNoteUpdater(cartDrawer);
  });

  observer.observe(cartDrawer, {
    childList: true,
    subtree: true
  });
});